"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Michael R., Owner",
  quote: "The Peachtree Post put our landscaping business directly in front of the exact Johns Creek homeowners we've been trying to reach for years.",
  type: "Verified Partner"
}, {
  id: 2,
  author: "Sarah L., Director",
  quote: "Being the exclusive real estate partner on the mailer has given us a level of prestige and local authority that digital ads simply can't match.",
  type: "Verified Partner"
}, {
  id: 3,
  author: "David K., Founder",
  quote: "The quality of the cardstock and the professional design immediately signal to our clients that we are a premium service provider.",
  type: "Verified Partner"
}];
export default function VoicesOfSatisfaction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235445" id="what-local-partners-say" className="relative py-24 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/atlanta_neighborhood_aerial_view.png)] bg-cover bg-center opacity-5 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <div className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold font-default text-secondary tracking-tight uppercase">
              What Local Partners Say
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto mt-6 rounded-full opacity-90" />
          </div>

          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full max-w-5xl mx-auto px-12 md:px-20">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                  <div className="flex flex-col items-center text-center py-8 md:py-12">
                    <p className="text-2xl md:text-4xl lg:text-5xl font-serif italic text-foreground mb-10 leading-relaxed md:leading-snug max-w-4xl">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex flex-col sm:flex-row items-center gap-4 mt-auto">
                      <span className="font-semibold text-secondary font-default text-lg tracking-wide">
                        {testimonial.author}
                      </span>
                      <Badge variant="outline" className="border-primary/40 text-secondary bg-primary/10 px-3 py-1 text-xs uppercase tracking-widest rounded-sm font-default">
                        {testimonial.type}
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden sm:flex size-12 rounded-full border-border/50 bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground shadow-lg transition-all duration-300" />
            <CarouselNext className="hidden sm:flex size-12 rounded-full border-border/50 bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground shadow-lg transition-all duration-300" />
          </Carousel>
        </div>
      </div>
    </section>;
}